import { Fragment, type ReactNode, useEffect, useMemo, useRef, useState } from 'react';

import styles from './BulletList.module.css';

type Props = {
  items: Array<ReactNode>;
};

export const BulletList = ({ items }: Props) => {
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [wrappedStates, setWrappedStates] = useState<boolean[]>([]);
  const bulletRefs = useRef<(HTMLDivElement | null)[]>([]);

  const itemsToRender = useMemo(() => items.filter(Boolean), [items]);

  const checkIfWrapped = () => {
    const newWrappedStates = itemRefs.current.map((itemRef, index) => {
      const bulletRef = bulletRefs.current[index];
      if (itemRef && bulletRef) {
        return itemRef.offsetTop > bulletRef.offsetTop;
      }
      return false;
    });
    setWrappedStates(newWrappedStates);
  };

  useEffect(() => {
    checkIfWrapped();
    window.addEventListener('resize', checkIfWrapped);

    return () => window.removeEventListener('resize', checkIfWrapped);
  }, [itemsToRender]);

  return (
    <div className={styles.bulletListContainer}>
      {itemsToRender.map((renderItem, index) => (
        <Fragment key={index}>
          {index > 0 && (
            <div
              ref={(el) => {
                bulletRefs.current[index] = el;
              }}
            >
              <div className={styles.bullet} data-wrapped={wrappedStates[index]} />
            </div>
          )}
          <div
            className={styles.itemsContainer}
            data-wrapped={wrappedStates[index]}
            ref={(el) => {
              itemRefs.current[index] = el;
            }}
          >
            {renderItem}
          </div>
        </Fragment>
      ))}
    </div>
  );
};
